import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { comparison } from '../data/content';
export function Comparison() {
  return <section aria-labelledby="comparison-title" className="bg-dusk" data-id="element-31" data-mp="1g8ui3cknwfu2">
      <div className="mx-auto max-w-5xl px-5 py-20 lg:py-24" data-id="element-32" data-mp="1l6cr12yoiv22">
        <div className="text-center" data-id="element-33" data-mp="1py490p3rrsgl">
          <p className="font-display text-lg font-semibold text-pumpkin" data-id="element-34" data-mp="1pz5u7mei1vc1">La realidad</p>
          <h2 id="comparison-title" className="mt-3 font-display text-4xl font-bold text-bone sm:text-5xl" data-id="element-35" data-mp="1uy0cmn8k1hvm">¿Cuánto cuesta NO tenerlo?</h2>
        </div>

        <div className="mt-12 overflow-hidden rounded-3xl ring-1 ring-line" data-id="element-36" data-mp="1zyelg7hzcvup">
          <table className="w-full border-collapse text-left" data-id="element-37" data-mp="23yeybnpfkyzn">
            <thead data-id="element-38" data-mp="28x8ejnw3r43i">
              <tr data-id="element-39" data-mp="28voy9xag4t1q">
                <th scope="col" className="w-1/2 bg-night px-5 py-4 font-display text-lg font-semibold text-mist sm:px-7" data-id="element-40" data-mp="28w72bg3cobk7">Sin el Megapack</th>
                <th scope="col" className="w-1/2 bg-pumpkin px-5 py-4 font-display text-lg font-semibold text-night sm:px-7" data-id="element-41" data-mp="eip9bdk6emhs">Con el Megapack</th>
              </tr>
            </thead>
            <tbody data-id="element-42" data-mp="1m2jvhkwkyzgz">
              {comparison.map(row => <tr key={row.without} className="border-t border-line align-top" data-id="element-43" data-mp="1h8frnaim37k4">
                  <td className="bg-night/60 px-5 py-4 sm:px-7" data-id="element-44" data-mp="1d9gljml594r3">
                    <span className="flex gap-3 text-mist" data-id="element-45" data-mp="189kl1xbnnvga">
                      <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-blood" aria-hidden="true" data-id="element-46" data-mp="18b5dnheet4bi" />
                      {row.without}
                    </span>
                  </td>
                  <td className="bg-plum px-5 py-4 sm:px-7" data-id="element-47" data-mp="20zawtzptel98">
                    <span className="flex gap-3 font-semibold text-bone" data-id="element-48" data-mp="1vydixzbu8ddj">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-slime" aria-hidden="true" data-id="element-49" data-mp="1w0pvty2qnxjq" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}